import React from 'react'
import Navbar from '../inc/Navbar'
import LogoSlider from './LogoSlider'
import {Link} from "react-router-dom";

function Services() {
  return (
    <div>
            <Navbar/>
            <br/>
            <br/>
            <br/>
            <br/>
              <div className='ackrishnagar'>
        <div className="album py-1">
          <div className="container mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Services</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
               <div className="album py-1">
        <div className="container mt-2">
          <h1 className='mb-1' style={{ color: "#142C74" }}><b>SAHA REFIGERATION & AIR CONDITIONS</b></h1>

          <h1 className='mb-1' style={{ color: "#F2192E" }}>Authorized Dealer & <b> Service </b></h1>
        </div>
      </div>
        <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href="tel:  7407194440" className="acservices" ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708"/>
</svg> Call Us <div className="spinner-grow text-light spinner-grow-sm" role="status">
          <span className="visually-hidden"> Loading...</span>
        </div> </a></div>
      <LogoSlider/>
      <br />
       <div className="album py-1">
          <div className="container">
      <p>SAHA Refrigeration & Air Conditions is an authorized dealer and service provider offering professional installation, maintenance, and repair services for leading air conditioning and refrigeration brands such as Mitsubishi Electric, Toshiba, Carrier, and Hitachi.
We provide reliable solutions for residential, commercial, and industrial cooling systems including cold rooms, air conditioners, and refrigeration units.</p>
<h6>SAHA Refrigeration & Air Conditions provides complete refrigeration and air conditioning solutions with authorized sales and service support for top international brands like <b>Mitsubishi Electric, Toshiba, Carrier, and Hitachi.</b></h6>

<h5 className='mb-2 mt-4'><b>Our services include:</b></h5>
<p className='mb-1'><small>Air Conditioner Installation & Repair</small></p>
<p className='mb-1'><small>Commercial & Industrial Refrigeration Systems</small></p>
<p className='mb-1'><small>Cold Room Installation and Maintenance</small></p>
<p className='mb-1'><small>Annual Maintenance Contracts (AMC)</small></p>
<p className='mb-1'><small>Spare Parts Supply & System Upgradation</small></p>
<p className='mb-3'><small>Energy Efficient Cooling Solutions</small></p>
<p style={{color:'darkBlue'}}><b>With skilled engineers and modern technology, we ensure reliable cooling performance, long equipment life, and energy savings for homes, offices, hotels, hospitals, and industrial facilities.</b></p>

 <button className="callbutton" type="submit">Helpline: 74071 94 440</button>
 <br/>
    </div>
    </div>
    <br/>
    </div>
  )
}

export default Services